// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1pl_-","ranges":"BmiRanges_ranges__2PDt2"};